import { useState } from "react";

/* ─────────────────────────────────────────────
   IMAGE IMPORTS — src/assets/images/footer/
───────────────────────────────────────────── */
import FooterLogo from "../../assets/images/footer/footer-logo.webp";

/* ─────────────────────────────────────────────
   ICON IMPORTS — src/assets/icons/footer/
───────────────────────────────────────────── */
import IconYoutube      from "../../assets/icons/footer/youtube.svg";
import IconSpotify      from "../../assets/icons/footer/spotify.svg";
import IconApplePodcast from "../../assets/icons/footer/apple-podcast.svg";
import IconChevronDown  from "../../assets/icons/footer/chevron-down.svg";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Roboto:wght@300;400;500&display=swap');

  .ftr-wrap *,
  .ftr-wrap *::before,
  .ftr-wrap *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .ftr-wrap {
    width: 100%;
    background: #000000;
    font-family: 'Roboto', sans-serif;
  }

  .ftr-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
    width: 100%;
  }

  /* ════════════════════════════════
     LOGO ROW
  ════════════════════════════════ */
  .ftr-logo-row {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0 24px;
  }
  .ftr-logo-link {
    display: inline-block;
    text-decoration: none;
  }
  .ftr-logo-link img {
    height: 124px;
    display: block;
    object-fit: contain;
  }

  /* ════════════════════════════════
     NAV ROW
  ════════════════════════════════ */
  .ftr-nav-row {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 44px;
  }
  .ftr-nav-item {
    position: relative;
  }
  .ftr-nav-link {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    text-decoration: none;
    padding: 0px 30px 0px 0px;
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    transition: color 0.2s;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 120%;
  }
  .ftr-nav-link:hover { color: #743FAC; }

  .ftr-nav-link.ftr-active {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  .ftr-nav-chevron {
    width: 10px;
    height: 10px;
    object-fit: contain;
    filter: brightness(0) invert(1);
    transition: transform 0.2s;
    opacity: 0.75;
  }
  .ftr-nav-item:hover .ftr-nav-chevron {
    transform: rotate(180deg);
  }

  /* Dropdown — opens upward */
  .ftr-dropdown {
    display: none;
    position: absolute;
    bottom: calc(100% + 2px);
    left: 50%;
    transform: translateX(-50%);
    min-width: 210px;
    background: #1a1a1a;
    border: 1px solid rgba(116,63,172,0.2);
    border-radius: 10px;
    padding: 8px;
    flex-direction: column;
    gap: 2px;
    box-shadow: 0 -1px 40px rgba(0,0,0,0.5);
    z-index: 100;
  }
  .ftr-nav-item:hover .ftr-dropdown {
    display: flex;
    animation: ftrDropIn 0.20s ease;
  }
  @keyframes ftrDropIn {
    from { opacity: 0; transform: translateX(-50%) translateY(8px); }
    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
  .ftr-dropdown-link {
    font-family: 'Roboto', sans-serif;
    font-size: 13.5px;
    color: rgba(255,255,255,0.75);
    text-decoration: none;
    padding: 9px 14px;
    border-radius: 6px;
    transition: background 0.15s, color 0.15s;
  }
  .ftr-dropdown-link:hover {
    background: rgba(116,63,172,0.15);
    color: #743FAC;
  }

  /* ════════════════════════════════
     PLATFORM LOGOS ROW
  ════════════════════════════════ */
  .ftr-platform-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 184px;
    padding-bottom: 48px;
  }
  .ftr-platform {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.2s;
  }
  .ftr-platform:hover { opacity: 0.75; transform: translateY(-2px); }

  .ftr-yt-icon  { width: 224px; height: 50px; display: block; object-fit: contain; }
  .ftr-sp-icon  { width: 166px; height: 50px; display: block; object-fit: contain; }
  .ftr-ap-icon  { width: 224px; height: 50px; display: block; object-fit: contain; }

  .ftr-yt-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: #ffffff;
    display: none;
  }
  .ftr-sp-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: #ffffff;
    display: none;
  }
  .ftr-ap-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
    display: none;
  }

  /* ════════════════════════════════
     DIVIDER
  ════════════════════════════════ */
  .ftr-divider {
    width: 982px;
    height: 1px;
    background: #515151;
    margin: 0 auto;
  }

  /* ════════════════════════════════
     COPYRIGHT
  ════════════════════════════════ */
  .ftr-copyright {
    text-align: center;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    padding: 24px 0;
  }

  /* ════════════════════════════════
     TABLET — 768px
  ════════════════════════════════ */
  @media (max-width: 768px) {
    .ftr-inner { padding-left: 32px; padding-right: 32px; }
    .ftr-nav-link { font-size: 14px; padding: 6px 10px; }
    .ftr-platform-row { gap: 40px; padding-bottom: 40px; }
    .ftr-yt-label, .ftr-sp-label { font-size: 20px; }
    .ftr-ap-label { font-size: 18px; }
    .ftr-logo-link img { height: 100px; }
    .ftr-nav-row { padding-bottom: 30px; }
    .ftr-divider { width: 100%; border-bottom: 1px solid #888888; }
  }

  /* ════════════════════════════════
     MOBILE — 480px
  ════════════════════════════════ */
  @media (max-width: 480px) {
    .ftr-inner { padding-left: 16px; padding-right: 16px; }

    .ftr-logo-row { padding: 36px 0 34px; border-bottom: 1px solid #888888; }
    .ftr-logo-link img { height: 100px; }

    /* nav stacked centered */
    .ftr-nav-row {
      flex-direction: column;
      align-items: center;
      gap: 0;
      padding-bottom: 30px;
      padding-top: 30px;
      border-bottom: 1px solid #888888;
    }
    .ftr-nav-item { width: 100%; text-align: center; }
    .ftr-nav-link {
      justify-content: center;
      padding: 12px 0;
      font-size: 16px;
      white-space: normal;
    }

    /* platforms stacked with icons + text labels */
    .ftr-platform-row {
      flex-direction: column;
      gap: 30px;
      padding-bottom: 30px;
      padding-top: 30px;
      align-items: center;
    }
    .ftr-platform { justify-content: center; }

    .ftr-yt-icon  { width: 147px; height: 33px; }
    .ftr-sp-icon  { width: 137px; height: 41px; }
    .ftr-ap-icon  { width: 184px; height: 40px; }

    .ftr-yt-label { display: none; }
    .ftr-sp-label { display: none; }
    .ftr-ap-label { display: none; }
    .ftr-divider { width: 100%; border-bottom: 1px solid #888888; }

    .ftr-copyright { font-size: 14px; padding: 24px 0px; }
  }
`;

/* ─────────────────────────────────────────────
   NAV DATA
───────────────────────────────────────────── */
const NAV_ITEMS = [
  { label: "Energizing India",  href: "/"                    },
  { label: "About Us",          href: "/about-us/"           },
  { label: "Our Team",          href: "/our-team/"           },
  { label: "Blog",              href: "/blog/"               },
  {
    label: "Conversations", href: "#",
    children: [
      { label: "Conversations",   href: "/conversations"    },
      { label: "DEEP DIVE",       href: "/all-episodes/"    },
      { label: "Watts Happening", href: "/watts-happening/" },
      { label: "Editorial",       href: "/"                 },
      { label: "1.5° Diaries",    href: "/"                 },
    ],
  },
  { label: "Behind the Scenes", href: "/behind-the-scenes/" },
  { label: "Contact Us",        href: "/contact"        },
];

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Footer() {
  const currentPath = window.location.pathname;

  const isActive = (item) => {
    if (item.href === "#") return false;
    if (item.href === "/") return currentPath === "/";
    return currentPath.startsWith(item.href);
  };

  return (
    <>
      <style>{CSS}</style>
      <footer className="ftr-wrap">
        <div className="ftr-inner">

          {/* Logo */}
          <div className="ftr-logo-row">
            <a href="/" className="ftr-logo-link">
              <img src={FooterLogo} alt="Energizing India Podcast" />
            </a>
          </div>

          {/* Nav links */}
          <nav className="ftr-nav-row">
            {NAV_ITEMS.map((item, i) => (
              <div key={i} className="ftr-nav-item">
                <a
                  href={item.href}
                  className={"ftr-nav-link" + (isActive(item) ? " ftr-active" : "")}
                >
                  {item.label}
                  {item.children && (
                    <img src={IconChevronDown} alt="" className="ftr-nav-chevron" />
                  )}
                </a>
                {item.children && (
                  <div className="ftr-dropdown">
                    {item.children.map((c, j) => (
                      <a key={j} href={c.href} className="ftr-dropdown-link">
                        {c.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Platform logos */}
          <div className="ftr-platform-row">
            <a
              href="https://www.youtube.com/@EnergizingIndiaPodcast"
              target="_blank" rel="noreferrer"
              className="ftr-platform"
            >
              <img src={IconYoutube} alt="YouTube" className="ftr-yt-icon" />
              <span className="ftr-yt-label">YouTube</span>
            </a>
            <a
              href="https://open.spotify.com/show/31CpjZm9DyfCR7sstBZlIf"
              target="_blank" rel="noreferrer"
              className="ftr-platform"
            >
              <img src={IconSpotify} alt="Spotify" className="ftr-sp-icon" />
              <span className="ftr-sp-label">Spotify</span>
            </a>
            <a
              href="https://podcasts.apple.com/in/podcast/energizing-india-podcast/id1530917254"
              target="_blank" rel="noreferrer"
              className="ftr-platform"
            >
              <img src={IconApplePodcast} alt="Apple Podcasts" className="ftr-ap-icon" />
              <span className="ftr-ap-label">&#xf8ff; Podcasts</span>
            </a>
          </div>

        </div>

        {/* Divider — full width */}
        <div className="ftr-divider" />

        {/* Copyright */}
        <div className="ftr-inner">
          <p className="ftr-copyright">
            © 2026 Energizing India Tv. All Rights Reserved. Designed &amp; Developed By <a href="https://eilandigital.com/" target="blank">Eilan Digital</a>
          </p>
        </div>

      </footer>
    </>
  );
}